import type { TrainingSearchQuery } from '@rover/rsdk/src/apiClient/latest/model/trainingSearchQuery';
import { snakeifyString } from '@rover/rsdk/src/modules/Network/object-utilities';

/**
 * This is a temporary type to fill the gap between us decoupling this util from the
 * HomepageSearchFilters and creating a new util in DEV-145976.
 */
export type TrainingSearchQueryParams = Omit<TrainingSearchQuery, 'centerlat' | 'centerlng'> & {
  centerlat?: string;
  centerlng?: string;
  behaviors?: string[];
  skills?: string[];
};

export const TRAINING_SEARCH_PARAMETERS = [
  'location',
  'centerlat',
  'centerlng',
  'locationType',
  'locationAccuracy',
  'rawLocationTypes',
  'behaviors',
  'skills',
];

export const snakifySearchQueryParams = (
  parametersDict: TrainingSearchQueryParams
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  for (const key of TRAINING_SEARCH_PARAMETERS) {
    const value = parametersDict[key];
    if (Array.isArray(value)) {
      searchParams.append(snakeifyString(key), value.join(','));
    } else if (typeof value === 'string') {
      searchParams.append(snakeifyString(key), value);
    }
  }
  return searchParams;
};

export const appendSearchQueryParams = (
  url: string,
  parametersDict: TrainingSearchQueryParams
): string => {
  const searchParams = snakifySearchQueryParams(parametersDict);
  const searchParamsString = searchParams.toString();
  if (searchParamsString) {
    return `${url}?${searchParams.toString()}`;
  }
  return url;
};
